// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"f2c9df0a","229":"80224e9d","406":"f863346c","781":"f7f82cfa","912":"fad8708b","954":"aac333a9","957":"f9dadbff"}[chunkId] + ".chunk.js";
};